module.exports = __webpack_public_path__ + "img/dp-flagship.1b1fe3db.png";